'use client';

import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

const MEMBERS = [
  { name: 'G-Dragon', slug: 'GD' },
  { name: '太陽', slug: 'Taeyang' },
  { name: 'T.O.P', slug: 'TOP' },
  { name: '大聲', slug: 'Daesung' },
  { name: '勝利', slug: 'Seungri' },
];

export default function Footer() {
  const t = useTranslations();

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-4 md:px-20 py-10 md:py-16">
        <div className="hidden md:flex md:flex-row justify-between items-start gap-12 mb-10">
          {/* Brand */}
          <div>
            <span
              className="text-2xl font-extrabold tracking-[3px] block mb-3 font-en"
              style={{
                background: 'linear-gradient(180deg, #E5A500 0%, #D4AF37 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              BIGBANG
            </span>
            <p className="text-sm text-[#666666] font-en">Instagram Archive · 2014-2022</p>
          </div>

          {/* Navigation */}
          <div className="flex gap-16">
            <div className="space-y-4">
              <h4 className="text-xs font-semibold tracking-wider text-[#888888]">
                {t('nav.archive')}
              </h4>
              <div className="space-y-3">
                <Link href="/archive" className="block text-sm text-[#666666] hover:text-[#D4AF37] transition-colors">
                  {t('features.archiveTitle')}
                </Link>
                {MEMBERS.slice(0, 2).map((member) => (
                  <Link
                    key={member.slug}
                    href={`/archive?member=${member.slug}`}
                    className="block text-sm text-[#666666] hover:text-[#D4AF37] transition-colors"
                  >
                    {t(`members.${member.slug}`)}
                  </Link>
                ))}
              </div>
            </div>
            <div className="space-y-4">
              <h4 className="text-xs font-semibold tracking-wider text-[#888888]">
                {t('members.all')}
              </h4>
              <div className="space-y-3">
                {MEMBERS.slice(2).map((member) => (
                  <Link
                    key={member.slug}
                    href={`/archive?member=${member.slug}`}
                    className="block text-sm text-[#666666] hover:text-[#D4AF37] transition-colors"
                  >
                    {t(`members.${member.slug}`)}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-6 border-t border-white/5 gap-2">
          <p className="text-xs text-[#555555]">
            © 2024 BIGBANG Archive. Fan-made project.
          </p>
          <p className="text-xs text-[#555555]">
            Made with ♥ for VIPs
          </p>
        </div>
      </div>
    </footer>
  );
}
